import { ClientError } from "@silo/types";
import { Config, Effect, Redacted } from "effect";
import { IncomingMessage } from "http";

export type ValidateCronSecret = ReturnType<typeof validateCronSecret>;
export type ValidateCronSecretSuccess =
  Effect.Effect.Success<ValidateCronSecret>;
export type ValidateCronSecretError = Effect.Effect.Error<ValidateCronSecret>;
export type ValidateCronSecretContext =
  Effect.Effect.Context<ValidateCronSecret>;

export function validateCronSecret(headers: IncomingMessage["headers"]) {
  return Effect.gen(function* () {
    const authHeader = headers["authorization"];

    const CRON_SECRET = yield* Config.redacted("CRON_SECRET");

    const isSecretValid =
      authHeader === `Bearer ${Redacted.value(CRON_SECRET)}`;

    yield* isSecretValid
      ? Effect.void
      : Effect.fail(
          new ClientError({ status: 401, message: "Invalid cron secret" })
        );
  });
}
